import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectWithDepositFilter } from 'shared/selectors/advancedFilters';

export const WithDepositContainer: FC = () => {
  const { label, value } = useSelector(selectWithDepositFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setWithDeposit', arguments: [newValue ? false : null] });
    },
    [onChange],
  );

  return (
    <InlineFilter>
      <Checkbox label={label} checked={value === false} onChange={handleChange} />
    </InlineFilter>
  );
};
